import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import axios from 'axios';
import LL from './LL'
let { lambda, appname } = window.app;

const Diagnostics = () => {
    

    return (
        <>
            <Header />
            <section className="about-us-section">
                <div className="container">
                    <h3 className="txt-48">Video Library</h3>
                    <p className="txt-16">Explore a curated collection of dermatopathology sessions, <br></br> expert case reviews, and diagnostic tutorials.</p>
                </div>
            </section>

            <LL />

            <Footer />

            
        </>
    );
};

export default Diagnostics;
